

import { createBrowserRouter } from "react-router-dom";


import DashboardLayout from "./layout/Dashboard";
import CenteredLayout from "./layout/CenteredLayout";
import Dashboard from "./pages/Dashboard";

import Onboard from "./pages/auth/Onboard";
import Root from "./layout/Root";
import Login from "./pages/auth/login";
import Signup from "./pages/auth/signup";
import OrderDetail from "./pages/OrderDetail";
import AllChat from "./pages/AllChat";
// import ManageStaff from "./pages/ManageStaff";
import StaffDetails from "./pages/ManageStaff/StaffDetails";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Catalog from "./pages/Catalog";
import ProductData from "./pages/ProductData";
import CatalogProduct from "./pages/Catalog/CatalogProduct";
import ShareProduct from "./pages/ShareProduct";
import ShareProductForCAD from "./pages/ShareProduct/ShareProductForCAD";
import ShareProductForCatalog from "./pages/ShareProduct/ShareProductForCatalog";
import SubmittedProduct from "./pages/ShareProduct/SubmiitedOrder";
import ErrorPage from "./pages/ErrorPage";
import HelpCenter from "./pages/HelpCenter";

export const router = createBrowserRouter([

    {
        path: '/',
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <DashboardLayout />,
                children: [
                    {
                        path: '',
                        element: <Dashboard />
                    },
                    {
                        // Standard centered content width; excludes the Kanban dashboard above.
                        element: <CenteredLayout />,
                        children: [
                            {
                                path: '/order/:id/:customer_id',
                                element: <OrderDetail />,
                            },
                            {
                                path: '/allchat',
                                element: <AllChat />,
                            },
                            {
                                path: '/catalog',
                                element: <Catalog />,
                            },
                            {
                                path: '/catalog-product/:type',
                                element: <CatalogProduct />,
                            },
                            // {
                            //     path: '/product',
                            //     element: <ProductData />,
                            // },
                            // {
                            //     path: '/manage-staff',
                            //     element: <ManageStaff />,
                            // },
                            {
                                path: '/manage-staff/:staffId',
                                element: <StaffDetails />,
                            },
                            {
                                path: '/notifications',
                                element: <Notifications />,
                            },
                            {
                                path: '/settings',
                                element: <Settings />,
                            },
                            {
                                path: '/product-view/:id', element: <ProductData />
                            },
                            {
                                path: '/submitted-order/:id', element: <SubmittedProduct />
                            },
                            {
                                path: '/help-center',
                                element: <HelpCenter />
                            }
                        ]
                    }
                ],
                errorElement: <ErrorPage />

            },

        ]
    },
    {
        element: <CenteredLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '/:business_name/share/:id',
                element: <ShareProduct />,
            },
            {
                path: '/:business_name/share_product/:token',
                element: <ShareProductForCAD />,
            },
            {
                path: '/:business_name/share_catalog/:token',
                element: <ShareProductForCatalog />,
            },
        ]
    },
    {
        path: '/signup',
        element: <Signup />,
        errorElement: <ErrorPage />
    },
    {
        path: '/login',
        element: <Login />,
        errorElement: <ErrorPage />
    },
    {
        path: '/onboard',
        element: <Onboard />,
        errorElement: <ErrorPage />
    },
])